<template>
  <div>
    <v-row v-if="includeSubheader">
      <v-subheader>{{ subheaderText }}</v-subheader>
    </v-row>
    <v-row class="mt-0">
      <v-col cols="12" md="4">
        <v-select :color="color" :dense="dense" :disabled="disabled"
                  :filled="filled"
                  :item-color="color" :items="GenderTypes.Items" :outlined="outlined"
                  :readonly="readonly"
                  :rounded="rounded"
                  :rules="[RuleFactory.required()]"
                  :solo="solo"
                  :value="gender"
                  label="Geschlecht/Anrede"
                  prepend-icon="mdi-human-greeting-variant"
                  @input="$emit('update:gender', $event)"
        >
          <template v-slot:item="{item}">
            <v-list-item-avatar>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title v-text="item.text"/>
              <v-list-item-subtitle v-text="item.salutation"/>
            </v-list-item-content>
          </template>
        </v-select>
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field :color="color" :dense="dense"
                      :disabled="disabled"
                      :filled="filled"
                      :label="gender === GenderTypes.FAMILY ? 'Vornamen' : 'Vorname'"
                      :outlined="outlined"
                      :readonly="readonly"
                      :rounded="rounded"
                      :rules="requireFirstName ? [RuleFactory.required('Dieses Feld ist erforderlich.')] : []"
                      :solo="solo"
                      :value="firstName"
                      prepend-icon="mdi-card-account-details"
                      @input="$emit('update:firstName', $event)"
        />
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field :color="color" :dense="dense" :disabled="disabled" :filled="filled"
                      :outlined="outlined"
                      :readonly="readonly"
                      :rounded="rounded"
                      :rules="[RuleFactory.required()]"
                      :solo="solo"
                      :value="lastName"
                      label="Nachname"
                      prepend-icon="mdi-card-account-details"
                      @input="$emit('update:lastName', $event)"
        />
      </v-col>
    </v-row>
  </div>

</template>

<script lang="ts">

import Vue from 'vue';
import {GenderTypes} from '@/enums/GenderTypes.enum';
import {RuleFactory} from '@/helpers/ruleFactory.helper';

export default Vue.extend({
  props: {
    gender: {
      type: Object as () => GenderTypes,
      required: true,
    },
    firstName: {
      type: String,
      required: true,
    },
    lastName: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: 'info',
    },
    includeSubheader: {
      type: Boolean,
      default: true,
    },
    subheaderText: {
      type: String,
      default: 'Persönliche Informationen',
    },
    requireFirstName: {
      type: Boolean,
      default: true,
    },
    outlined: {
      type: Boolean,
      default: true,
    },
    rounded: {
      type: Boolean,
      default: true,
    },
    filled: {
      type: Boolean,
      default: false,
    },
    solo: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    RuleFactory: () => RuleFactory,
    GenderTypes: () => GenderTypes,
  },
});

</script>
